import { useRef, useEffect } from 'react';
import eq from '../utils/eq';
import KEYCODES from '../utils/KEYCODES';
var isESC = eq(KEYCODES.ESC);
var isTAB = eq(KEYCODES.TAB);
export default function useConfineTabbing(el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    onEnter = _ref.onEnter,
    onExit = _ref.onExit,
    selectors = _ref.selectors;
  var sels = selectors || 'button:not(:disabled), a';
  var prevFocus = useRef(null);
  var firstEl = useRef(null);
  var lastEl = useRef(null);
  var timeoutId = useRef(null);
  useEffect(function () {
    function focusHandler(e) {
      var target = e.relatedTarget;
      if (!(el && el.contains(target))) {
        // save previous focus
        prevFocus.current = target;
        // entering the container for the first time
        onEnter && onEnter();
      }
    }
    function blurHandler(e) {
      var elGainingFocus = e.relatedTarget;
      if (elGainingFocus === null) {
        // exiting the container
        onExit && onExit();
      }
    }
    function keydownHandler(e) {
      var target = e.target;
      var isFirst = target === firstEl.current;
      var isLast = target === lastEl.current;
      var elToFocus = null;
      if (isESC(e.which) && prevFocus.current) {
        elToFocus = prevFocus.current;
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
        timeoutId.current = setTimeout(function () {
          elToFocus && elToFocus.focus();
        }, 50);
        return;
      }

      // only care if it's the first or last tabbable element
      if (!isTAB(e.which) || !(isFirst || isLast)) {
        return;
      }
      if (e.shiftKey) {
        if (isFirst) {
          elToFocus = lastEl.current;
        }
      } else if (isLast) {
        elToFocus = firstEl.current;
      }
      if (el) {
        // don't want the previous focus to change during this confinement
        // scenario, as the next focusable element can receive focus briefly,
        // so turn off the handler
        // @ts-ignore
        el.removeEventListener('focusin', focusHandler);
      }
      timeoutId.current = setTimeout(function () {
        elToFocus && elToFocus.focus();
        if (el) {
          // now we can turn the focusin handler back on
          // @ts-ignore
          el.addEventListener('focusin', focusHandler, false);
        }
      }, 0);
    }
    if (el) {
      var tabbables = Array.from(el.querySelectorAll(sels)).filter(function (el) {
        return el.offsetParent;
      });
      firstEl.current = tabbables[0];
      lastEl.current = tabbables[tabbables.length - 1];
      // @ts-ignore
      el.addEventListener('focusin', focusHandler, false);
      // @ts-ignore
      el.addEventListener('focusout', blurHandler, false);
      el.addEventListener('keydown', keydownHandler, false);
    }
    return function () {
      if (el) {
        // @ts-ignore
        el.removeEventListener('focusin', focusHandler);
        // @ts-ignore
        el.removeEventListener('focusout', blurHandler);
        el.removeEventListener('keydown', keydownHandler);
      }
    };
  }, [el, onEnter, onExit, sels]);
}